enum SeverityBucket {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

enum ColorMode {
  Light = 'light',
  Dark = 'dark',
}

export { SeverityBucket, ColorMode };
